import {TranslationService} from '@nuskin/ns-util';

export let TranslationMixin = (superClass) => class extends superClass {
    constructor() {
        super();
    }

    ready() {
        super.ready();
        // console.log("IN MIXIN!!!! ", this.tagName);
        // console.log("id:", this.id);
        if (!this.id) {
            TranslationService().setCurrentContext(this.tagName.toLowerCase());
        } else {
            TranslationService().setCurrentContext(this.id);
        }
    }
}